import React , { useState , useContext , useEffect } from "react";
import { Link, useNavigate , NavLink } from "react-router-dom";
import logo from "../../assets/web/images/logo.png";
import  { WebAssetsContext }  from "../../App";
import  { WebContext }  from "../../Webroute";
import { toplevelAlerts , alertDanger , loggedInCustomerDetails } from "../../functions/Function";
//import  { loggedInUserDetails }  from "../../../functions/Function";


const  HeaderHome = (props) => {
    const WebData = useContext(WebContext);
    const navigate = useNavigate();
  const WebAssets = useContext(WebAssetsContext);
  const [toggle, setToggle] = useState(false);

  const AlertMessage  = () =>
  {
    
    if(props.isloggedIn == true)
    {
        return (
            <div className="container-fluid">
                {toplevelAlerts(props.customer)}
            </div>
        );
        
    }
    
  }
 
  const logoURL = () =>
  {
    if(props.isloggedIn == true)
    {
        return '/home';
    }else
    {
        return '/';
    }
  }
  
  useEffect(() => {
        AlertMessage()
  }, []);
 
 

  
  return (
    <>
    
        <header className="ivo-header ">
        <div className={props.isloggedIn == true ? 'container-fluid' : 'container'}>
            <nav className="navbar navbar-expand-lg navbar-light  p-0 ">

                <Link className="navbar-brand header-logo ivo-logo mr-0" to={logoURL()}><img className="img-fluid" src={logo} /></Link>
                <button  onClick={() => setToggle(!toggle)}  className="navbar-toggler collapsed" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">

                    <input type="checkbox" name="" id="" />
                    <div className="hamburger-lines">
                        <span className="line line1"></span>
                        <span className="line line2"></span>
                        <span className="line line3"></span>
                    </div>
                </button>
                <div className={toggle == false ? 'collapse navbar-collapse' : 'collapse navbar-collapse show' } id="navbarSupportedContent">
                   
                    <ul className="navbar-nav ivo-header-navbar  mr-auto">
                        {props.isloggedIn == true ?
                        <>
                        <li className="nav-item ">
                            <NavLink end  className="nav-link" to="/home">COMMODITY <span className="sr-only">(current)</span></NavLink>
                        </li>   
                        <li className="nav-item ">
                            <NavLink className="nav-link "  to="/home/market" >MARKET </NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink  className="nav-link "  to="/home/fund" >FUNDS </NavLink>
                        </li>

                        </>
                             : '' }
                        </ul>
                       



                   
                    <div className="nabar-icon-box ">
                        <ul className="nabar-icon-box-ul">
                            {props.isloggedIn == true ?
                            <li title="My Account">
                                <NavLink to="/home/my-account" className="right-side-menu" >
                                    <i className="fa-solid fa-circle-user"></i>
                                </NavLink>
                            </li>
                             : '' }


                            
                            <li title="Help">
                                <NavLink to="/help"  className="right-side-menu">
                                    <i className="fa-solid fa-circle-question"></i>

                                </NavLink>
                            </li>
                            {props.isloggedIn == true ?     
                            <li title="Sign out">
                                <Link onClick={()=>props.customerLogout()} >
                                    <i className="fa fa-sign-out"></i>

                                </Link>
                            </li>
                            : "" }

                            {props.isloggedIn == false ?

                            <div className="d-flex justify-content-end" id="navbarSupportedContent">

                            <button className="btn ivo-site-btn ivo-site-btn-v-2"> <Link to="login">Log In</Link></button>
                            <button className="btn ivo-site-btn ivo-site-btn-v-3 ml-2"> <Link to="signup">Sign Up</Link></button>

                            </div>
                            : '' }
                        </ul>

                        
                    </div>
                </div>
            </nav>
        </div>

    </header>

       
                            
       <AlertMessage />
    </>

  );
}

export default HeaderHome;
